<template>
  <div class="flex flex-1 flex-col overflow-x-hidden">
    <MRow>
      <MCol :size="12">
        <OrderItemSection
          :value="calculatedPurchase"
          disabled
          :custom-form-fields="availablePriceField"
          :vendor-id="resource.vendorId"
          :hidden-columns="['remainingQuantity', 'assetTypeId']"
        />
      </MCol>
    </MRow>
    <MDivider />
    <FlotoForm>
      <MRow :gutter="0" class="flex-1">
        <MCol :size="6" class="mt-2">
          <MRow :gutter="0">
            <MCol class="mx-2">
              <h6
                class="text-neutral-light flex justify-between cursor-pointer items-center"
              >
                {{ $tc('shipping') }} {{ $tc('address') }}
              </h6>
            </MCol>
            <MDivider class="mt-0 mb-2" />
          </MRow>
          <MRow :gutter="0">
            <MCol class="mx-2">
              <AddressForm
                key="shipping"
                :value="resource.shippingAddress"
                disabled
              />
            </MCol>
          </MRow>
        </MCol>
        <MCol :size="6" class="mt-2">
          <MRow :gutter="0">
            <MCol class="ml-2 flex">
              <h6 class="text-neutral-light">
                {{ $tc('billing') }} {{ $tc('address') }}
              </h6>
            </MCol>
            <MDivider class="mt-0 mb-2" />
          </MRow>
          <MRow :gutter="0">
            <MCol class="mx-2">
              <AddressForm
                key="billing"
                :value="resource.billingAddress"
                disabled
              />
            </MCol>
          </MRow>
        </MCol>
        <MDivider class="mt-0 mb-2" />
        <MCol :size="12">
          <MRow :gutter="0">
            <MCol class="mx-2">
              <FlotoFormItemReadOnly
                :value="resource.terms"
                :label="`${$tc('terms')}`"
              >
                {{ resource.terms || '---' }}
              </FlotoFormItemReadOnly>
            </MCol>
          </MRow>
        </MCol>
        <MCol :size="6">
          <MRow :gutter="0">
            <MCol class="mx-2">
              <span v-if="(resource.signingAuthorities || []).length">
                <SigningAuthorityMapping
                  v-model="resource.signingAuthorities"
                  :module-name="$constants.PURCHASE"
                  disabled
                />
              </span>
              <span v-else>
                <div class="ant-form-item-label read-only-label">
                  <label>
                    {{ $tc('signing_authority') }}
                  </label>
                </div>
                <div>---</div>
              </span>
            </MCol>
          </MRow>
        </MCol>
      </MRow>
      <template v-slot:submit>
        <span />
      </template>
    </FlotoForm>
  </div>
</template>

<script>
import AddressForm from '@components/address-form.vue'
import { calculateTotal } from '../helpers/utils'
import OrderItemSection from './form-components/order-item-section'
import SigningAuthorityMapping from '../components/signing-authority-mapping'
export default {
  name: 'PurchaseDetailTab',
  components: { OrderItemSection, AddressForm, SigningAuthorityMapping },
  props: {
    resource: { type: Object, required: true },
    priceCustomFields: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    availablePriceField() {
      const fieldValueDetails = this.resource.fieldValueDetails || {}
      return this.priceCustomFields.filter((f) => {
        if (f.hidden) {
          return fieldValueDetails[f.id]
        }
        return f
      })
    },
    calculatedPurchase() {
      return calculateTotal(this.resource, this.availablePriceField)
    },
  },
}
</script>
